var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20a15.4 15.4 0 1 1 30.9 0 15.4 15.4 0 0 1-30.9 0ZM20 7.7a12.2 12.2 0 1 0 0 24.5 12.2 12.2 0 0 0 0-24.5ZM26.9 22v-2.4h-6.5V13h-2.5v9h9Z"
  })));
};
export default SvgClock;